<div class="home-container">
  <app-search-section></app-search-section>
  <!-- END! search-section-home -->

  <app-home-popular-category></app-home-popular-category>
  <!-- END! popular-category -->

  <div #adsCategory id="1">
    <section class="product-main area-pink">
      <div class="container">
        <div class="product-list-main">
          <app-product-list-right
            [title]="'HOME.ALL_ADS_CATEGORY.TITLE' | translate"
            [filter]="{ filter: { vip: true } }"
            [vipOnly]="true">
          </app-product-list-right>
        </div>
      </div>
    </section>
  </div>

  @if (currentElement >= 1) {
    <div #productArea id="2">
      <section class="product-main">
        <div class="container">
          <div class="product-list-main">
            <app-product-list-right
              [title]="'PRODUCT_LIST.ALL_SEX_ADS_IN_MYESCORT' | translate"
              [description]="'HOME.APP_PRODUCT_AREA.DESCRIPTION' | translate"
              [filter]="{ filter: undefined }">
            </app-product-list-right>
          </div>
        </div>
      </section>
    </div>
  }

  <!-- END! all-ads-category -->

  @if (currentElement >= 2) {
    <app-ad-creation-guide></app-ad-creation-guide>
  }
  <!-- END! ad-creation-guide -->
</div>
